export type CustomerCategoryType = 0 | 1 | 2 | 3 | 4

export interface CustomerCategory {
  id: number
  name: string
  type: CustomerCategoryType
  type_label: string
  description: string
  created_at: number
  updated_at: number
}

export interface CustomerCategorySavePayload {
  name: string
  type: CustomerCategoryType
  description: string
}

export const CUSTOMER_CATEGORY_TYPES: Array<{ value: CustomerCategoryType; label: string }> = [
  { value: 0, label: '普通客户' },
  { value: 1, label: 'VIP潜在' },
  { value: 2, label: '新VIP' },
  { value: 3, label: 'VIP在期' },
  { value: 4, label: 'VIP沉寂' },
]

export const VIP_LEVEL_OPTIONS = [
  { value: 0, label: '表1' },
  { value: 1, label: '表2' },
  { value: 2, label: '表3' },
  { value: 3, label: '表4' },
  { value: 4, label: '表5' },
  { value: 5, label: '表6+' },
]
